import { FC } from "react";
import Filter from "shared/components/Filter";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import SearchField from "shared/components/SearchField";
import { useTagsPage } from "../../context";
import ClearButton from "../ClearButton";

const PageFilterBar: FC = () => {
  const {
    isDisabledTagTypesButton,
    searchData,
    tagTypeFilterData,
    onClearFilters,
  } = useTagsPage();

  return (
    <FlexCenter columnGap={"1rem"}>
      <SearchField placeholder="Search tag" {...searchData} />
      <Filter
        {...tagTypeFilterData}
        disabled={isDisabledTagTypesButton}
        title="Primary tag"
      />
      {tagTypeFilterData.selectedValue.length > 0 && (
        <ClearButton onClearFilters={onClearFilters} />
      )}
    </FlexCenter>
  );
};

export default PageFilterBar;
